import { Container, Col, Row, BreadcrumbItem } from "reactstrap";
import * as ViewQL from "queries/view";
import * as Notify from "@repoflow/form-schema/notify";
import { CancellableContent } from "@repoflow/components/content-cancel";
import { Mutation, Button, useSectionContext } from "@repoflow/components/section";

export const Sidebar = () => null;
export const Indice = () => <><BreadcrumbItem>Remove</BreadcrumbItem></>;

export const Content = ({ history, match: { params } }) => {
  const { parent: { base } } = useSectionContext();

  return (
    <CancellableContent>
      <Row>
        <Col>
          Removing the view <b>{params.viewId}</b>? This removes the saved query
          and nothing else — the tables it reads are untouched.
        </Col>
      </Row>
      <Mutation
        mutation={ViewQL.remove}
        update={ViewQL.update(params)}
        onMutate={({ handler }) => handler({ variables: params })}
        onCompleted={() => history.replace(base)}
        onError={(error) => Notify.error(error.toString())}
      >
        {({ mutate }) => (
          <Container className="mt-4">
            <Row>
              <Col>
                <Button onClick={() => mutate()}>Remove</Button>
              </Col>
            </Row>
          </Container>
        )}
      </Mutation>
    </CancellableContent>
  );
};
